export default __webpack_public_path__ + "static/media/icon-hamburger.fc176eb2.svg";